import classNames from 'classnames'
import * as React from 'react'

import { DefaultContent } from 'react-content-engine'
import { Field } from 'react-redux-form'

interface TextareaProps {
  model?: string | ((state: any) => string)
  inputName: string
  placeholder?: string
  maxChar?: number
  value?: string
  onChange?: (text: string) => void
  hasOuterShadow?: boolean
  required?: boolean
  disabled?: boolean
}

interface TextareaState {
  value: string
}

class Textarea extends React.Component<TextareaProps, TextareaState> {
  private className = classNames(
    this.props.hasOuterShadow ? 'has-outer-shadow' : '',
  )

  constructor(props: TextareaProps) {
    super(props)
    this.state = {
      value: props.value || '',
    }
    this.handleChange = this.handleChange.bind(this)
  }

  public handleChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const value = e.currentTarget.value
    if (
      this.props.maxChar !== undefined &&
      this.props.maxChar - value.length < 0
    ) {
      return
    }

    this.setState({
      value,
    })
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  }

  public componentDidUpdate(oldProps: TextareaProps) {
    if (
      typeof this.props.value !== 'undefined' &&
      this.props.value !== this.state.value
    ) {
      // Props value was changed in some other way
      this.setState({ value: this.props.value || '' })
    }
  }

  public render() {
    const charLeft = (this.props.maxChar || 0) - this.state.value.length
    const Wrapper = this.props.model ? Field : React.Fragment
    const wrapperProps = { model: this.props.model || '' }
    const textareaProps = this.props.model
      ? {}
      : {
          value: this.state.value,
          required: this.props.required || false,
          disabled: this.props.disabled || false,
        }
    return (
      <div className={`form-element-wrapper`}>
        <Wrapper {...wrapperProps}>
          <textarea
            {...textareaProps}
            onChange={this.handleChange}
            className={this.className}
            placeholder={this.props.placeholder}
            maxLength={this.props.maxChar}
            id={this.props.inputName}
            name={this.props.inputName}
          />
          {this.props.maxChar ? (
            <span className="counter">
              <DefaultContent
                contentKey="max-characters"
                vars={{ charLeft: charLeft + '' }}
              >
                {`Max. ${charLeft} characters`}
              </DefaultContent>
            </span>
          ) : null}
        </Wrapper>
      </div>
    )
  }
}

export default Textarea
